import React from 'react';

export const LatLongData = {
    LatContext: 18.54,
    LongContext: 85.65
}
export const LatitudeContext = React.createContext(LatLongData);


